import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText, Scale, AlertTriangle, BookOpen, Sparkles, Ban, Mail } from 'lucide-react';

const SECTIONS = [
  {
    icon: BookOpen,
    title: 'Objet de l\'application',
    body: [
      "Mibeko est un outil de consultation des textes de loi de la République Démocratique du Congo (Constitution, Codes, Ordonnances-lois, Arrêtés) enrichi d'un moteur de recherche et d'un assistant intelligent.",
      "L'application est mise à disposition gratuitement, à titre informatif et pédagogique. Elle vise à démocratiser l'accès au droit congolais pour les citoyens, étudiants, professionnels et curieux.",
    ],
  },
  {
    icon: Scale,
    title: 'Valeur juridique — Mibeko n\'est PAS un avocat',
    body: [
      "Les textes affichés dans Mibeko sont des reproductions à titre documentaire des lois congolaises. Seuls les textes publiés au Journal Officiel de la République Démocratique du Congo font foi devant les tribunaux.",
      "L'Assistant IA de Mibeko est un outil d'aide à la compréhension. Ses réponses ne constituent en aucun cas un conseil juridique personnalisé et n'engagent pas la responsabilité de l'éditeur. Pour toute décision ayant des conséquences légales, financières ou personnelles, consultez un avocat, un notaire ou un professionnel du droit qualifié.",
    ],
  },
  {
    icon: Sparkles,
    title: 'Utilisation acceptable',
    body: [
      "Vous êtes libre d'utiliser Mibeko pour consulter, rechercher et partager les articles de loi. Nous encourageons la citation de sources dans vos travaux, mémoires, articles et publications.",
      "Vous vous engagez à ne pas utiliser l'application à des fins illégales, frauduleuses, ou pour induire autrui en erreur sur le contenu du droit en vigueur.",
      "Toute tentative d'atteinte à la sécurité de l'infrastructure (attaques, extraction massive automatisée, contournement des protections) est interdite et pourra faire l'objet de poursuites.",
    ],
  },
  {
    icon: AlertTriangle,
    title: 'Limitations & mises à jour',
    body: [
      "Malgré nos efforts pour maintenir un contenu à jour, des erreurs typographiques, oublis ou décalages avec les dernières promulgations peuvent subsister. Signalez-nous toute anomalie via les canaux ci-dessous.",
      "L'application peut être temporairement indisponible pour des raisons techniques (maintenance, mise à jour, panne fournisseur) sans que la responsabilité de MolaCorp puisse être engagée.",
    ],
  },
  {
    icon: Ban,
    title: 'Propriété intellectuelle',
    body: [
      "Les textes de loi sont, par nature, dans le domaine public. Le contenu éditorial de Mibeko (résumés, mots-clés, agencement, interface, logos, marque « Mibeko ») est protégé par le droit d'auteur et appartient à MolaCorp.",
      "Toute reproduction commerciale, extraction systématique ou création d'un service concurrent à partir des données de Mibeko est soumise à autorisation écrite préalable.",
    ],
  },
  {
    icon: Mail,
    title: 'Contact & droit applicable',
    body: [
      "Les présentes conditions sont régies par le droit congolais. Tout litige relatif à leur interprétation ou à leur exécution relève de la compétence exclusive des juridictions de Kinshasa.",
      "Pour toute question, signalement ou demande : contact@mibekordc.com",
    ],
  },
];

const TermsPage = () => {
  const navigate = useNavigate();
  return (
    <div data-testid="terms-page">
      <div className="back-header">
        <button className="back-btn" onClick={() => navigate(-1)} data-testid="back-btn-terms">
          <ArrowLeft />
        </button>
        <h1>Conditions d'utilisation</h1>
      </div>

      <div className="blue-header" data-testid="terms-header">
        <FileText style={{ width: 24, height: 24, marginBottom: 8, opacity: 0.85 }} />
        <h1>Conditions d'utilisation</h1>
        <p>Les règles d'usage de Mibeko — dernière mise à jour : 27 février 2026.</p>
      </div>

      <div className="page-container">
        <p style={{ fontSize: 14, color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: 24 }}>
          En téléchargeant, installant ou utilisant Mibeko, vous acceptez sans réserve les
          conditions ci-dessous. Si vous n'êtes pas d'accord avec l'une d'entre elles, veuillez
          désinstaller l'application.
        </p>

        {SECTIONS.map((s, idx) => {
          const Icon = s.icon;
          return (
            <section key={idx} className="legal-section" data-testid={`terms-section-${idx}`}>
              <div className="legal-section-head">
                <span className="legal-section-icon"><Icon /></span>
                <h2>{s.title}</h2>
              </div>
              {s.body.map((line, i) => (
                <p key={i} className="legal-section-body">{line}</p>
              ))}
            </section>
          );
        })}

        <p className="legal-footnote">
          MolaCorp se réserve le droit de faire évoluer ces conditions. Les changements
          notables seront signalés à l'ouverture de l'application.
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
